import useWebChatAPIContext from '/druid/useWebChatAPIContext';

export default function useErrorBoxClass() {
  const { internalErrorBoxClass } = useWebChatAPIContext();

  return [internalErrorBoxClass];
}
